import { useSession } from "../SessionProvider";
import { format } from 'date-fns';

export default function ServerStats() {
    const { userLogin } = useSession();
    return (
        <>
            {userLogin && (
                <div className="text-center  bg-gray-400 text-white p-1 text-sm">
                    <strong>API updated at:</strong> {format((userLogin.modified_at), 'dd-MMM-yyyy HH:mm:ss')}
                    <strong className="pl-5">Invoices app updated at:</strong> {format((__BUILD_TIME__), 'dd-MMM-yyyy HH:mm:ss')}
                </div>
            )
            }
        </>


    );
};
